import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import "./About.css";

const About = () => {
  const navigate = useNavigate();

  const goToNavigation = () => {
    navigate("/navigation");
  };

  // ✅ When the component loads, scroll to top
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div className="about">
      {/* ===== HEADER SECTION ===== */}
      <header className="header-top">
        <div className="header-left">
          <img src="/logo.jpg" alt="Zhufu Logo" className="header-logo" />
        </div>

        <div className="header-right">
          <nav className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </nav>

          <button className="menu-btn" onClick={goToNavigation}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </header>

      {/* ===== ABOUT US INTRO ===== */}
      <section className="about-intro">
        <h2 className="slide-in-left">About Us</h2>
        <img src="https://res.cloudinary.com/dd2jk2uv2/image/upload/v1761935048/team_utbqse.jpg" alt="Zhufu Agency team" className="about-image" loading="lazy" />
        <p className="about-description">
          Zhufu Agency was established in March 2025.
          The wealth of experience that the founder has gained over the years
          is evident in the value of the company.
          At Zhufu Agency, we're passionate about delivering exceptional event
          experiences through our team of young, energetic, and talented professionals.
          As a leading provider of outsourced event staff, we specialize in supplying
          skilled waiters, chefs, bartenders, ushers, registration crew, hostesses, and runners
          to events of all sizes.
          Our team is built on a foundation of enthusiasm, dedication, and a commitment
          to excellence. We believe that our youthful energy and creativity bring a unique
          perspective to every event, ensuring that our clients and their guests have
          an unforgettable experience. Whether you're hosting a corporate event, party, gala dinner, private dinner, wedding,
          or social gathering, our staff are trained to provide top-notch service, attention
          to detail, and a warm, welcoming atmosphere.
        </p>
      </section>

      {/* ===== MISSION SECTION ===== */}
      <section className="mission-section">
        <div className="mission-image">
          <img src="https://res.cloudinary.com/dd2jk2uv2/image/upload/v1761935179/namhla_nwx53a.jpg" alt="Our mission" loading="lazy" />
        </div>

        <div className="mission-text">
          <h2>Why choose us?</h2>
          <ul>
            <li>Professional and skilled event staff.</li>
            <li>Young, energetic, and motivated team members.</li>
            <li>Customized staffing solutions tailored to your event needs.</li>
            <li>Reliable and efficient service.</li>
            <li>Flexibility to accommodate events of all sizes.</li>
            <li>Passionate about delivering exceptional experiences.</li>
          </ul>
          <p>
            At Zhufu Agency, we're committed to making your event a success.
            Let us take care of the staffing, so you can focus on what matters most –
            your guests and the celebration!
          </p>
        </div>
      </section>

      {/* ===== CORE VALUES SECTION ===== */}
      <section className="core-values-layout">
        <h2 className="core-title">Our Core Values</h2>

        <div className="core-content">
          {/* Left side - Professionalism */}
          <div className="core-item left">
            <h3>Professionalism</h3>
            <p>
              We pride ourselves on providing reliable, well-trained staff who
              represent our brand with grace and efficiency.
            </p>
          </div>

          {/* Center image */}
          <div className="core-image-center">
            <img src="https://res.cloudinary.com/dd2jk2uv2/image/upload/v1761935191/pride_fiflok.jpg" alt="Waiter holding glass" loading="lazy" />
          </div>

          {/* Right side - Excellence */}
          <div className="core-item right">
            <h3>Excellence</h3>
            <p>
              We go the extra mile to ensure every client and guest leaves impressed —
              every single time.
            </p>
          </div>

          {/* Bottom - Passion */}
          <div className="core-item bottom">
            <h3>Passion</h3>
            <p>
              Our team thrives on delivering memorable experiences fueled by
              enthusiasm and creativity.
            </p>
          </div>

          {/* Decorative Arrows */}
          <div className="arrow arrow-left">
            <img src="/photos/arrow.jpg" alt="arrow left" loading="lazy" />
          </div>
          <div className="arrow arrow-right">
            <img src="/photos/arrow.jpg" alt="arrow right" loading="lazy" />
          </div>
          <div className="arrow arrow-bottom">
            <img src="/photos/arrow.jpg" alt="arrow bottom" loading="lazy" />
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <h3>ZHUFU AGENCY</h3>
            <p>
              Welcome to Zhufu Agency, your premier partner for exceptional
              event staffing solutions. We specialize in outsourcing skilled and
              professional waiters, ushers, bartenders, hostesses, registration
              crew, and runners to ensure seamless execution of your events.
            </p>
      
            {/* ✅ Social Icons moved here */}
            <div className="social-icons">
              <a
                href="https://www.tiktok.com/@zhufuangency?_t=ZS-8z2JfPdP5RX&_r=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok />
              </a>
              <a
                href="https://www.instagram.com/zhufuagency?igsh=MXJwZDMzdWVpcG9kbg%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/zhufuagency"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
      
          <div className="footer-right">
            <h3>QUICK LINKS</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
      
        <div className="footer-bottom">
          <div>
            <h4>CONTACT US</h4>
            <p>
              Email Us:{" "}
              <a href="mailto:Zhufuagency1@gmail.com">Zhufuagency1@gmail.com</a>
            </p>
            <p>
              Call Us: <a href="tel:0659966846">065 996 6846</a>
            </p>
          </div>
          <p className="credits">© 2025 Zhufu. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About;
